import HeaderAndInfo from './HeaderAndInfo';
import InputAndCopy from './InputAndCopy';

export default function LinkShortApp() {
    
    return (
        <div>
            <HeaderAndInfo/>
            <InputAndCopy />
        </div>
    )
}
